import { checkStatus } from '../util';
import { ROOT } from '../../constants/root';

export function getMapLayers() {
	return function(dispatch, getState) {		
		
		// Builds credentials
		const URL = `${ROOT}/maplayer/`;		
		
		// Set visual UI
		dispatch(isFetchingGerenciarMaplayers(true));		

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'				
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {			
			dispatch(setMapLayers(json));
		})
		.finally(() => {
			dispatch(isFetchingGerenciarMaplayers(false));
		})
		.catch((e) => {
			console.error(e);			
		});
	};
}

export function Save(layers) {
	return function(dispatch, getState) {		
		
		// Builds credentials
		const URL = `${ROOT}/maplayer/`;		
		
		// Set visual UI
		dispatch(isSavingGerenciarMaplayers(true));
		dispatch(setSaveMessage("Salvando..."));

		return fetch(URL, {
			method: 'PUT',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(layers)			
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {			
			// dispatch(getMapLayers());
			dispatch(setSaveMessage("Salvo com sucesso!"));
		})
		.finally(() => {
			dispatch(isSavingGerenciarMaplayers(false));
			timeoutToWipeMessage(dispatch);
		})
		.catch((e) => {
			console.error(e);
			dispatch(setSaveMessage("Erro ao salvar."));
		});
	};
}

export function changeOneMapLayer(id, openOrCheck) {
	return function(dispatch, getState) {	
		dispatch(setOneMapLayer(id, openOrCheck));
	};
}

function isFetchingGerenciarMaplayers(bool) {
	return {
		type: "IS_FETCHING_GERENCIAR_MAPLAYERS",
		bool
	};	
}

function isSavingGerenciarMaplayers(bool) {
	return {
		type: "IS_SAVING_GERENCIAR_MAPLAYERS",
		bool
	};	
}

export function setSaveMessage(message) {
	return {
		type: "SET_SAVE_MESSAGE",
		message
	};
}

export function setMapLayers(mapLayers) {
	return {
		type: "SET_MAP_LAYERS",
		mapLayers
	};
}

export function setOneMapLayer(id, openOrCheck) {
	return {
		type: "SET_ONE_MAP_LAYER",
		id, openOrCheck
	};
}

const timeoutToWipeMessage = (dispatch) => {
	setTimeout(() => {
		dispatch(setSaveMessage(""));
	}, 5000);
};


// WEBPACK FOOTER //
// ./src/state/gerenciarMaplayer/actions.js